export default {
  init() {
    // JavaScript to be fired on the checkout page
    // jQuery('#order_review .shop_table .woocommerce-shipping-totals th').attr('colspan', '3');
    // jQuery('#order_review .shop_table .woocommerce-shipping-totals td').attr('colspan', '2');
  },
};
